export interface DockLog {
  dockLogId: string;
  receiveDate: string;
  purchaseOrderNumber: string;
  description: string;
  vendorId: string;
  vendorName: string;
  carrierId: string;
  carrierName: string;
  containerName: string;
  itemCode: string;
  itemId: string;
  itemTypeId: string;
  itemTypeName: string;
  packingSlip: string;
  warehouseId: string;
  warehouseName: string;
  sublocationId: string;
  sublocationName: string;
  shipmentDocumentId: string;
  shipmentDocumentItemId: string;
  shipmentDocumentItemStatusId: string;
  shipmentDocumentItemStatusName: string;
  quantity?: number;
  notes: string;

  requisitionId?: string;
  requisitionItemId?: string;
}
